module.exports = __webpack_public_path__ + "static/media/success-green.5e719ae4.svg";